<div class="bloco" [formGroup]="form">
  <div class="row g-3">
    <div class="col-12 col-md-6">
      <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
        <mat-label>CST COFINS</mat-label>
        <mat-select formControlName="codigoCst" (selectionChange)="onCstSelecionado()">
          <mat-option [value]="null">Selecione</mat-option>
          @for (c of listaCstCofinsSaida; track c.codigo) {
            <mat-option [value]="c.codigo">{{ c.codigo }} - {{ c.descricao }}</mat-option>
          }
        </mat-select>
        @if (listaCstCofins.length === 0) {
          <mat-hint>Lista indisponível - verifique o aviso acima</mat-hint>
        }
      </mat-form-field>
    </div>

    @if (texto) {
      <div class="col-12">
        <app-alert-card [type]="texto.alertaTipo" [title]="texto.alertaTitulo">
          {{ texto.alertaTexto }}
        </app-alert-card>
      </div>
    } @else {
      <div class="col-12">
        <app-empty-state icon="percent" title="Selecione o CST"
          subtitle="Os campos e os valores apurados aparecem conforme o código informado."></app-empty-state>
      </div>
    }

    @if (ativo('pCOFINS')) {
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Base de cálculo</mat-label>
          <input matInput type="text" inputmode="decimal" [currencyMask]="valorMask" formControlName="valorBaseCalculo" class="campo-numero">
        </mat-form-field>
      </div>
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Alíquota COFINS (%)</mat-label>
          <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualAliquota" class="campo-numero">
          @if (form.get('percentualAliquota')?.hasError('required') && form.get('percentualAliquota')?.touched) {
            <mat-error>Alíquota da COFINS é obrigatória.</mat-error>
          }
        </mat-form-field>
      </div>
    }

    @if (ativo('vAliqProd')) {
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Quantidade (unidade tributável)</mat-label>
          <input matInput type="text" inputmode="decimal" [currencyMask]="decimalMask" formControlName="quantidadeBaseCalculo" class="campo-numero">
        </mat-form-field>
      </div>
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Valor por unidade (R$)</mat-label>
          <input matInput type="text" inputmode="decimal" [currencyMask]="currencyMask" formControlName="valorAliquotaUnidade" class="campo-numero">
          @if (form.get('valorAliquotaUnidade')?.hasError('required') && form.get('valorAliquotaUnidade')?.touched) {
            <mat-error>Alíquota por unidade é obrigatória.</mat-error>
          }
        </mat-form-field>
      </div>
    }

    @if (ativo('pCOFINSST')) {
      <div class="col-12">
        <div class="sub-section-container">
          <div class="sub-section-title">
            <mat-icon>swap_horiz</mat-icon>
            <span>COFINS-ST</span>
          </div>
          <div class="row g-3">
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Base de cálculo ST</mat-label>
                <input matInput type="text" inputmode="decimal" [currencyMask]="valorMask" formControlName="valorBaseCalculoSt" class="campo-numero">
              </mat-form-field>
            </div>
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Alíquota COFINS-ST (%)</mat-label>
                <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualAliquotaSt" class="campo-numero">
                @if (form.get('percentualAliquotaSt')?.hasError('required') && form.get('percentualAliquotaSt')?.touched) {
                  <mat-error>Preenchimento obrigatório.</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Valor COFINS-ST</mat-label>
                <input matInput type="text" inputmode="decimal" [currencyMask]="valorMask" formControlName="valorCofinsSt" class="campo-numero">
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    }

    @if (algumAtivo(['pCOFINS', 'vAliqProd'])) {
      <div class="col-12">
        <div class="sub-section-container">
          <div class="sub-section-title">
            <mat-icon>calculate</mat-icon>
            <span>Valores apurados</span>
          </div>
          @if (isRecalculoPendente || form.get('valorCofins')?.value == null) {
            <app-empty-state icon="calculate" title="Nenhum valor apurado"></app-empty-state>
          } @else {
            <div class="row g-3">
              <div class="col-6 col-md-3">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                  <mat-label>Base</mat-label>
                  <input matInput type="text" [value]="form.get('valorBaseCalculo')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
                </mat-form-field>
              </div>
              <div class="col-6 col-md-3">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                  <mat-label>Alíquota (%)</mat-label>
                  <input matInput type="text" [value]="form.get('percentualAliquota')?.value || 0 | abnt: 'quantidade': 2" [disabled]="true" class="campo-numero">
                </mat-form-field>
              </div>
              <div class="col-6 col-md-3">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                  <mat-label>Valor da COFINS</mat-label>
                  <input matInput type="text" [value]="form.get('valorCofins')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
                </mat-form-field>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
